<template>
    <div class="box">
        <el-form ref="form" :model="form" label-width="130px" :rules="rules">
            <el-form-item label="真实姓名" prop="name">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="codeId">
                <el-input v-model="form.codeId"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="form.phone"></el-input>
            </el-form-item>
            <el-form-item label="联系地址">
                <el-input type="textarea" v-model="form.addRess"></el-input>
            </el-form-item>
            <div style="display:flex;">
                <el-form-item label="上传身份证正面" prop="imageOff">
                    <div>
                        <el-upload class="avatar-uploader" action="https://www.nays.com.cn/center//common/upload"
                            :show-file-list="false" :on-success="(res, file) => handleAvatarSuccess(res, file, 0)"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="form.imageOff" :src="form.imageOff" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </div>
                </el-form-item>
                <el-form-item label="上传身份证反面" style="margin-left:20px;" prop="imageCode">
                    <div>
                        <el-upload class="avatar-uploader" action="https://www.nays.com.cn/center//common/upload"
                            :show-file-list="false" :on-success="(res, file) => handleAvatarSuccess(res, file, 1)"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="form.imageCode" :src="form.imageCode" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </div>
                </el-form-item>
            </div>
            <el-form-item label="上传营业执照" prop="imageUrl">
                <el-upload class="avatar-uploader" action="https://www.nays.com.cn/center//common/upload"
                    :show-file-list="false" :on-success="(res, file) => handleAvatarSuccess(res, file, 2)"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="form.imageUrl" :src="form.imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>

            <el-form-item>
                <el-checkbox v-model='privacyBox'>我已阅读</el-checkbox><span @click.stop="getPrivacy"
                    style="color:blue;vertical-align:middle;cursor: pointer;">《隐私条例》</span>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit('form')">立即提交</el-button>
            </el-form-item>
        </el-form>
        <el-dialog title="隐私政策" :visible.sync="dialogVisible" width="30%">
            <span>隐私条款信息隐私条款信息隐私条款信息隐私条款信息隐私条款信息隐私条款信息隐私条款信息</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { getInfo } from '@/api/myStripe'
export default {
    data() {
        var validatePass = (rule, value, callback) => {
            let reg = /^([u4e00-u9fa5]{1,20}|[a-zA-Z.s]{1,20})$/
            if (reg.test(value)) {
                callback(new Error('请输入正确的姓名格式'));
            } else {
                callback();
            }
        };
        var validateCode = (rule, value, callback) => {
            let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
            if (!reg.test(value)) {
                console.log(123123)
                callback(new Error('请输入正确的身份证格式'));
            } else {
                callback();
            }
        };
        var validatePhone = (rule, value, callback) => {
            let reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
            if (!reg.test(value)) {
                console.log(123123)
                callback(new Error('请输入正确的手机格式'));
            } else {
                callback();
            }
        };
        return {
            privacyBox: false,
            userData: JSON.parse(localStorage.getItem("userdata")),
            form: {
                name: '',
                codeId: '',
                phone: '',
                addRess: '',
                imageOff: '',
                imageCode: '',
                imageUrl: '',
            },
            dialogVisible: false,
            rules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    { validator: validatePass, trigger: 'blur' }
                ],
                codeId: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' },
                    { validator: validateCode, trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' },
                    { validator: validatePhone, trigger: 'blur' }
                ],
                imageOff: [
                    { required: true, message: '请选择身份证照片', trigger: 'blur' },
                ],
                imageCode: [
                    { required: true, message: '请选择身份证照片', trigger: 'blur' },
                ],
                imageUrl: [
                    { required: true, message: '请选择营业执照', trigger: 'blur' },
                ],
            }
        }
    },
    created(){
        console.log(this.$route.query.type,'typetttttt')
    },
    methods: {
        onSubmit(form) {
            if (this.privacyBox) {
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        let newArr = {
                            address: this.form.addRess,
                            idCard: this.form.codeId,
                            idCardBack: this.form.imageCode,
                            idCardFront: this.form.imageOff,
                            mobile: this.form.phone,
                            realName: this.form.name,
                            type: this.$route.query.type,
                            userName: this.userData.userName,
                            userId: this.userData.userId,
                            userAccount: this.userData.phonenumber,
                            businessLicense:this.form.imageUrl,
                            areaId:this.userData.areaid
                        }
                        getInfo(newArr).then(res => {
                            if(res.data.code==0){
                                this.$message({
                                message: '申请成功，审核完成后会为您自动开通',
                                type: 'success'
                                });
                                this.$refs[form].resetFields()
                                setTimeout(()=>{
                                    this.$route.query.type=='0'?this.$router.push('/myStripe'):this.$router.push('/myPeriod')
                                },1000)
                                
                            }else{
                                this.$message({
                                message: res.data.msg,
                                type: 'warning'
                                });
                            }
                        })
                    }
                })
            } else {
                this.$message({
                    message: '请勾选隐私协议',
                    type: 'warning'
                });

            }
        },
        handleAvatarSuccess(res, file, type) {
            if (type == 0) {
                this.form.imageOff = URL.createObjectURL(file.raw);
            } else if (type == 1) {

                this.form.imageCode = URL.createObjectURL(file.raw);
            } else {
                this.form.imageUrl = URL.createObjectURL(file.raw);
                console.log(this.form.imageUrl)
            }
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg' || 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!或PNG 格式');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        getPrivacy() {
            this.dialogVisible = true
        }
    }
}
</script>
<style scoped lang="less">
.box {
    padding-right: 120px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border: 1px solid gainsboro;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.uploadCold {
    display: flex;
    // justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/views/myOrder/propertyCenter/myAppay.vue